var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0.5H2.5C1.125 0.5 0 1.625 0 3V23C0 24.375 1.125 25.5 2.5 25.5H17.5C18.875 25.5 20 24.375 20 23V3C20 1.625 18.875 0.5 17.5 0.5ZM2.5 3H8.75V13L5.625 11.125L2.5 13V3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseTraining);
export default __webpack_public_path__ + "static/media/course_training.59b3dfefc27ae6bd5d345692da2892f4.svg";
export { ForwardRef as ReactComponent };